const ACTIONABLE_STATUSES = new Set(["draft", "outOfPolicy", "inPolicy", "needsApproval"]);
const SUBMITTABLE_STATUSES = new Set(["inPolicy", "needsApproval"]);

export const normalizeReceiptStatus = (status) => `${status || ""}`.trim();

function getMissingDraftFields(receipt = {}) {
	const missing = [];
	if (!receipt.categoryId) missing.push("Category");
	if (!receipt.description) missing.push("Purpose");
	if (!receipt.amount || Number(receipt.amount) <= 0) missing.push("Amount");
	if (!receipt.date) missing.push("Date");
	if (!receipt.merchant) missing.push("Merchant");
	if (!Array.isArray(receipt.attachments) || receipt.attachments.length === 0) missing.push("Attachment");
	return missing;
}

function buildViolationHint(violations = []) {
	if (!Array.isArray(violations) || violations.length === 0) return "";
	const first = `${violations[0] || ""}`.trim();
	if (!first) return "";
	if (violations.length === 1) return first;
	return `${first} (+${violations.length - 1} more)`;
}

export function getReceiptReimbursementEligibility(receipt = {}) {
	const status = normalizeReceiptStatus(receipt.status);
	const hasCategory = Boolean(receipt.categoryId);
	const canShowAction = ACTIONABLE_STATUSES.has(status);
	const canDrag = canShowAction;
	const canAddToReimbursement = hasCategory && SUBMITTABLE_STATUSES.has(status);
	const draftMissingFields = getMissingDraftFields(receipt);
	const violationHint = buildViolationHint(receipt.violations);

	let disabledReason = "";
	let toastReason = "";
	let reasonDetails = [];
	if (status === "outOfPolicy") {
		disabledReason = violationHint ? `Not eligible: ${violationHint}` : "Not eligible: policy violations found. Resolve issues to continue.";
		toastReason = violationHint ? `Out of policy: ${violationHint}. Resolve and try again.` : "This receipt is out of policy. Resolve violations, then move to reimbursement.";
		reasonDetails = Array.isArray(receipt.violations) ? receipt.violations.filter(Boolean) : [];
	} else if (!hasCategory) {
		disabledReason = "Not eligible: category missing. Add category to continue.";
		toastReason = "Add a category to this receipt before moving it to reimbursement.";
		reasonDetails = ["Category is mandatory for reimbursement."];
	} else if (status === "draft") {
		disabledReason = draftMissingFields.length ? `Not eligible: complete ${draftMissingFields.join(", ")}.` : "Not eligible: receipt details are incomplete.";
		toastReason = draftMissingFields.length ? `Please complete: ${draftMissingFields.join(", ")}.` : "Complete receipt details, then move it to reimbursement.";
		reasonDetails = draftMissingFields.map((field) => `${field} is missing or incomplete.`);
	} else if (!canAddToReimbursement) {
		disabledReason = "Not eligible for reimbursement in current status.";
		toastReason = "This receipt is not ready yet. Update it and try again.";
		reasonDetails = [`Current status: ${status || "unknown"}.`];
	}

	let dropState = "none";
	let dropMessage = "";
	if (canDrag) {
		if (!hasCategory) {
			dropState = "missingCategory";
			dropMessage = "This receipt does not have a category specified, add a category first";
		} else if (status === "outOfPolicy") {
			dropState = "outOfPolicy";
			dropMessage = "This receipt is out of your expense policy, please resolve the violations first";
		} else if (canAddToReimbursement) {
			dropState = "eligible";
			dropMessage = "Drop here to add this receipt";
		}
	}

	return {
		status,
		canShowAction,
		canDrag,
		canAddToReimbursement,
		disabledReason,
		toastReason,
		reasonDetails,
		dropState,
		dropMessage,
	};
}
